<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getMyOrders } from "../../api"
    import { myOrdersToken } from "../../store"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import { navigate } from "../../../../vendor/svelte-routing"
    import { fade } from "svelte/transition"
    import { title } from "../../config"
    import { formatPriceCurrency, langField } from "../../i18n"
    import Index from "../SEO/Index.svelte"

    export let token: string

    let offset = 0
    let hasMore = false
    let loading = false
    let count = 0

    let orders: Order[] = []
    const setOrders = (_orders) => {
        orders = [...orders, ..._orders.data]
        count = _orders.count
        hasMore = orders.length < count
        offset = orders.length
    }

    $: $myOrdersToken = token

    let error
    const load = async () => {
        hasMore = false
        loading = true

        try {
            const _orders = await getMyOrders(token, null, "-insertTime", 5, offset)
            setOrders(_orders)
        } catch (e) {
            error = e
        }
        loading = false
    }

    const gotoLinkRequest = () => {
        $myOrdersToken = ""
        navigate("/order")
    }

    let oldToken: string
    $: if (token != oldToken && token) {
        offset = 0
        load()
        oldToken = token
    }
</script>

<Index noIndex="{true}" title="{$_('my-orders.my-orders')}" metaDescription="{$_('meta.description')}" />
<section class="section-type-1 section_padding checkout">
    <div class="container">
        <h1>{$_("my-orders.my-orders")}</h1>
        <p>{@html $_("my-orders.intro-html")}</p>
        <p>
            <a href="/order" on:click|preventDefault="{gotoLinkRequest}">{$_("my-orders.click-link-prompt")}</a>
        </p>

        {#if token}
            {#if error}
                {#if error.data?.status == 403}
                    <p>
                        <b style="color: var(--error);">{$_("my-orders.access-denied")}</b>
                    </p>
                    <p>{$_("my-orders.link-is-invalid")}</p>
                {:else}
                    {JSON.stringify(error)}
                {/if}
            {:else}
                <div class="myorders">
                    {#each orders as order (order.id)}
                        <div class="order" in:fade="{{}}">
                            <div class="product_images">
                                {#each order.cart || [] as item, idx}
                                    {#if idx < 2}
                                        {#if item.product?.images?.length}
                                            <div class="image">
                                                <img
                                                    src="{item.product?.images[0].file?.src}"
                                                    alt="{langField(item.product.name, '')}"
                                                />
                                                {#if idx == 1 && order.cart.length > 2}
                                                    <div class="morepics">
                                                        +
                                                        {order.cart.length - 2}
                                                    </div>
                                                {/if}
                                            </div>
                                        {/if}
                                    {/if}
                                {/each}
                            </div>
                            <div class="order_details">
                                <div class="header">
                                    <h3>
                                        {$_("my-orders.order-from-date", {
                                            values: {
                                                date: new Date(order.insertTime).toLocaleDateString(),
                                            },
                                        })}
                                    </h3>
                                    <div class="ordernum">
                                        {$_("my-orders.order-number-short")}:
                                        {order.sequence}
                                    </div>
                                </div>
                                <div class="price">
                                    {$formatPriceCurrency(order.sum?.totalGross)}
                                </div>
                                <a href="/order/{token}/{order.id}" class="btn btn-secondary"
                                    >{$_("my-orders.view-order")}</a
                                >
                            </div>
                        </div>
                    {:else}
                        <p>
                            <b>{@html $_("my-orders.no-order-for-email-html")}</b>
                        </p>
                    {/each}
                    {#if hasMore}
                        <div class="center_btn">
                            <!-- svelte-ignore a11y-invalid-attribute -->
                            <a
                                href=""
                                class="btn btn-secondary"
                                on:click|preventDefault="{(e) => {
                                    load()
                                }}">{$_("my-orders.load-more")}</a
                            >
                        </div>
                    {/if}
                </div>
                {#if loading}
                    <MiniLoader />
                {/if}
            {/if}
        {/if}
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";
    .myorders {
        .order {
            border-bottom: dotted 1px #ccc;
            padding: 40px 0px;
            .flex();
            @media (max-width: 420px) {
                flex-direction: column;
            }
            .product_images {
                width: 40%;
                margin: -5px;
                .flex();
                @media (max-width: 900px) {
                    flex-direction: column;
                }
                @media (max-width: 420px) {
                    width: 100%;
                    margin-bottom: 20px;
                    flex-direction: row;
                }
                .image {
                    position: relative;
                    margin: 5px;
                    height: 220px;
                    @media (max-width: 1300px) {
                        height: 16vw;
                    }
                    @media (max-width: 900px) {
                        height: 20vw;
                    }
                    @media (max-width: 420px) {
                        height: 30vw;
                    }
                    .morepics {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: var(--surface-3);
                        color: var(--on-surface-3);
                        .flex();
                        align-items: center;
                        justify-content: center;
                        font-size: 32px;
                        @media (max-width: 768px) {
                            font-size: 22px;
                        }
                    }
                    background: var(--surface);
                    .flex();
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
            }
            .order_details {
                width: 60%;
                padding-left: 30px;
                @media (max-width: 420px) {
                    width: 100%;
                    padding-left: 0px;
                }
                .header {
                    margin-bottom: 30px;
                    h3 {
                        margin: 0px;
                    }
                    .ordernum {
                        font-size: 14px;
                    }
                }
                .price {
                    color: var(--primary);
                    font-size: 1.6rem;
                    margin-bottom: 10px;
                }
            }
        }
    }
</style>
